export const getFilteredValue = <T extends { name: string }>(
  items: T[] = [],
  value: string
) => {
  const search = value.trim().toLowerCase();
  return items.filter(item => item.name.toLowerCase().includes(search));
};
